import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4af38d6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-index", "data-hex"]

import { onMounted, ref } from 'vue';
import { useMotions } from '@vueuse/motion'
import { getGameSetTransitions, gameSetLeave } from './transitions';
import { getColorWithSimilarityInRange, generateGradientSquare } from 'util/color-util';
import flatten from 'lodash/flatten';
import { swap } from 'util/util';
import chroma from 'chroma-js';
//import Sortable from 'sortablejs';
import Sortable from 'src/lib/sortable.core.esm.js';
import { random } from 'lodash';

// const { game, audio } = useModule();

export default /*#__PURE__*/_defineComponent({
  __name: 'gradient-shape',
  props: {
    distanceMin: null,
    distanceMax: null,
    gridCount: null,
    swapCount: null
  },
  emits: ['enter'],
  setup(__props: any, { expose, emit }) {

const { 
    distanceMin = 50,
    distanceMax = 100,  
    gridCount = 6,
    swapCount = 3
} = __props as {
    distanceMin?: number,
    distanceMax?: number,
    gridCount?: number,
    swapCount?: number
}

_useCssVars(_ctx => ({
  "537dca24": (tileWidth.value)
}))




const c1 = chroma.random();
const c2 = getColorWithSimilarityInRange(c1, distanceMin, distanceMax);
const c3 = getColorWithSimilarityInRange(c2, distanceMin, distanceMax);
const c4 = getColorWithSimilarityInRange(c3, distanceMin, distanceMax);
const grid = ref<chroma.Color[][]>(generateGradientSquare(gridCount, [c1, c2, c3, c4]));
const gridFlat = ref<chroma.Color[]>(flatten(grid.value));
const tileWidth = ref(`${100 / gridCount}%`);

/**
 * Returns two grid indexs (flat grid) which have not yet been swapped or throws an error if all 
 * indexes have been swapped (which the game parameters should prevent).
 */
const alreadySwapped = ref<number[]>([]);
const getUnswappedIndexes = () : [number, number] => {
    if (alreadySwapped.value.length === gridFlat.value.length){
        throw new Error("getUnswappedIndexes(): All indexes have been swapped");
    }

    let index1 = random(0, gridFlat.value.length - 1);
    let index2 = random(0, gridFlat.value.length - 1);
    if (index1 === index2 || alreadySwapped.value.includes(index1) || alreadySwapped.value.includes(index2)){
        return getUnswappedIndexes();
    }

    return [index1, index2]
}

const getShuffledGridFlat = (count: number) => {
    const gridFlatShuffled = [...gridFlat.value];
    for (let i = 0; i < count; i ++){
        swap(gridFlatShuffled, ...getUnswappedIndexes());
    }
    return gridFlatShuffled;
}

const gridFlatShuffled = ref<chroma.Color[]>(getShuffledGridFlat(swapCount));

const gridEl = ref<HTMLElement>();
onMounted(() => {
    if (gridEl.value){
        new Sortable(gridEl.value, {
            animation: 200,
            swap: true,
            ghostClass: "k-sortable-ghost",  // Class name for the drop placeholder
            chosenClass: "k-sortable-chosen",  // Class name for the chosen item
            dragClass: "k-sortable-drag",  // Class name for the dragging item
            //swapThreshold: .25,
            //forceFallback: true
        });
    }
})

const isOrderValid = () => {
    if (gridEl.value){
        const gridElChildren = gridEl.value.children;
        for (let i = 0; i < gridElChildren.length; i++){
            if (gridElChildren[i].getAttribute('data-hex') !== gridFlat.value[i].hex()){
                return false;
            }
        }
        return true;
    }
    return false;
}

/**
 * Removes any border radiuses on the grid elements. This is necessary because any corner elements that
 * are moved around will still have their borders otherwise, causing a visual bug.
 */
const fixBorderRadius = () => {
    if (gridEl.value) {
        gridEl.value.style.overflow = 'hidden';
        const gridElChildren = gridEl.value.children;
        Array.from(gridElChildren).forEach(child => (<HTMLDivElement> child).style.borderRadius = '0px');
    }
}

const entered = ref(false);
const handleTransitionComplete = (index: number) => {
    if (entered.value === false && index === (gridCount * gridCount) - 1){
        fixBorderRadius();
        entered.value = true;
        emit('enter');
    }
}

let cols = gridCount;
const getBorderRadiusStyle = (index: number) => {
    let style = {}, pos = index + 1;
    if (pos === 1) style = { ...style, borderTopLeftRadius: '10px' };
    if (pos === cols) style = { ...style, borderTopRightRadius: '10px' };
    if (pos === (gridFlat.value.length - cols) + 1) style = { ...style, borderBottomLeftRadius: '10px' };
    if (pos === gridFlat.value.length) style = { ...style, borderBottomRightRadius: '10px' };
    return style;
}

expose({
    isOrderValid,
    leave: () => gameSetLeave(useMotions(), ['up', 'scatter', 'collect', 'grow'])
})

return (_ctx: any,_cache: any) => {
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "gridEl",
    ref: gridEl,
    class: "k-gradient-shape"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gridFlatShuffled.value, (color, i) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", _mergeProps({
        class: "k-gradient-shape__item",
        "data-index": i,
        "data-hex": color.hex(),
        style: { 
            background: color.hex(),
            ...getBorderRadiusStyle(i)
        }
      }, _unref(getGameSetTransitions)(i, { onComplete: handleTransitionComplete })), null, 16, _hoisted_1)), [
        [_directive_motion, `btnMotion${i}`]
      ])
    }), 256))
  ], 512))
}
}

})